import * as React from "react";

export const PeopleIcon = ({ isActive, ...props }: { isActive?: boolean }) => {
  return (
    <svg width={18} height={15} viewBox="0 0 18 15" fill="none" {...props}>
      <g
        opacity={isActive ? 1 : 0.3}
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12.243 13.273v-1.364a2.728 2.728 0 00-2.727-2.727H4.06a2.727 2.727 0 00-2.727 2.727v1.364M6.788 6.455a2.727 2.727 0 100-5.455 2.727 2.727 0 000 5.455zM16.334 13.273v-1.364A2.727 2.727 0 0014.29 9.27M11.56 1.089a2.727 2.727 0 010 5.284" />
      </g>
    </svg>
  );
};
